import React from "react";
import "../../../style/about.css";
import NoticeBoard from "../../../images/Notice_Board.jpg";

const About = () => {
  return (
    <div className="about_section">
      <div className="container">
        <div>
          <h2>Notice Board</h2>
          <div className="content_wrapper">
            <div className="left_side">
              <h3>Latest Notice</h3>
            </div>

            <div className="right_side">
              <img src={NoticeBoard} alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
